module.exports = __webpack_public_path__ + "static/img/1.60c121f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/sp/1.png
// module id = irXs
// module chunks = 0